import { type BlokProps, getMedia } from "@trydig/storyblok";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import { Asset } from "@/components/ui/Asset";
import { Container } from "@/components/ui/Container";
import { FullWidthMedia } from "@/components/ui/FullWidthMedia";
import { Typography } from "@/components/ui/Typography";
import type { MediaStoryblok } from "@/generated/sb/sb-types";

export const MediaBlok = ({ blok }: BlokProps<MediaStoryblok>) => {
	const asset = blok.asset ? getMedia(blok.asset) : null;

	if (!asset) return null;

	const Content = () => {
		if (blok.fullWidth) {
			return <FullWidthMedia asset={blok.asset} label={blok.asset?.name} />;
		}
		return (
			<Container>
				<div className="flex flex-col gap-grid-section-vertical-sm">
					<div className="relative overflow-hidden aspect-3/4 md:aspect-3/2 lg:aspect-21/9">
						<Asset asset={blok.asset} sizes="(min-width: 1024px) 90vw, 100vw" />
					</div>
					{blok.asset?.name && (
						<Typography variant="body-xs-reg" as="p" className="text-text-dark-text-2">
							{blok.asset?.name}
						</Typography>
					)}
				</div>
			</Container>
		);
	};

	return (
		<BlokWrap editable={blok} className="pb-grid-section-vertical-md">
			<Content />
		</BlokWrap>
	);
};
